import type {
  AggregatedBundlePriceDto,
  AggregatedPaymentDto,
} from '~/models/ListingProduct.api.model';

/**
 * returns an array of 4 values, where the first value is
 * the direct payment, and the remaining 3 are monthly payments.
 *
 * The direct payment comes from the bundle prices object that have
 * the BindingPeriod.Months value of 0, the others come from the bundle prices
 * that are of BindingPeriod.Months 24.
 */
export const selectMonthlyPaymentOptions = (
  bundlePrices: AggregatedBundlePriceDto[],
  selectedPlanId: number,
): AggregatedPaymentDto[] => {
  const bundlePricesWithAndWithoutBindingPeriod = bundlePrices.filter(
    (bundlePrice) => bundlePrice.Plan?.PlanId === selectedPlanId,
  );

  if (!bundlePricesWithAndWithoutBindingPeriod) {
    return [];
  }

  const paymentsWithoutBindingPeriod =
    bundlePricesWithAndWithoutBindingPeriod.find(
      (bundlePrice) => bundlePrice.BindingPeriod.Months === 0,
    )?.Payments;

  const paymentsWithBindingPeriod =
    bundlePricesWithAndWithoutBindingPeriod.find(
      (bundlePrice) => bundlePrice.BindingPeriod.Months > 0,
    )?.Payments;

  if (!paymentsWithBindingPeriod || !paymentsWithoutBindingPeriod) {
    return [];
  }

  const theDirectPayment = paymentsWithoutBindingPeriod.find(
    (payment) => payment.Time === 1,
  );

  if (!theDirectPayment) {
    return [];
  }

  const payments = [theDirectPayment].concat(
    paymentsWithBindingPeriod.filter((payment) => payment.Time > 1),
  );

  return payments;
};
